module.exports = __webpack_public_path__ + "static/Trapcode Hero Particles 1-aa222eaa23d766b3ffa63b1b2b787c05.gif";